module.exports = __webpack_public_path__ + "img/logo-brand.54250cb2.png";